module.exports = {"name":"ima","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.0","built":"2018-05-17","repo":"https://bitbucket.org/npaw/ima-adapter-js","libVersion":"6.2.6","features":{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getRendition","getTitle","getTitle2","getResource","getPosition"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 28
// module chunks = 0